var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.987 17.2882L16.922 13.5922C16.7299 13.4175 16.4774 13.3244 16.2178 13.3324C15.9583 13.3404 15.712 13.449 15.531 13.6352L13.138 16.0962C12.562 15.9862 11.404 15.6252 10.212 14.4362C9.02004 13.2432 8.65904 12.0822 8.55204 11.5102L11.011 9.11619C11.1975 8.93532 11.3062 8.68901 11.3142 8.4294C11.3222 8.16978 11.2289 7.91723 11.054 7.72519L7.35904 3.66119C7.18408 3.46854 6.94092 3.35169 6.68119 3.33545C6.42146 3.3192 6.16564 3.40485 5.96804 3.57419L3.79804 5.43519C3.62515 5.6087 3.52196 5.83964 3.50804 6.08419C3.49304 6.33419 3.20704 12.2562 7.79904 16.8502C11.805 20.8552 16.823 21.1482 18.205 21.1482C18.407 21.1482 18.531 21.1422 18.564 21.1402C18.8086 21.1265 19.0394 21.0229 19.212 20.8492L21.072 18.6782C21.2421 18.4812 21.3283 18.2256 21.3124 17.9659C21.2966 17.7062 21.1798 17.463 20.987 17.2882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ebd646bb6b88e5ae621d2301dd877596.svg";
export { ForwardRef as ReactComponent };